<template>
	<div :class="items.length === 0 ? 'grid-empty' : 'card-grid'" v-loading="loading">
		<div class="flex flex-wrap items-stretch -mx-2">
			<div v-for="(item, index) in items"
				class="px-2 mb-4"
				:class="itemType(item) + '-grid' + ' ' + columnClass"
			>
				<component
					:is="itemType(item)"
					:item="item"
					:index="index"
					:key="index"
				></component>
			</div>
		</div>

		<div v-if="!loading && items.length === 0">
			<div class="alert alert-info mb-0">{{ noItemsMessage }}</div>
		</div>

		<div class="grid-actions text-center pt-3 py-md-2" v-if="items.length > 0">
			<slot name="grid-actions">
				<template v-if="paginate">
					<a v-if="pagination && pagination.to < pagination.total"
						class="btn btn-default"
						@click="loadMore"
					>
						<template v-if="loadingMore">Loading...</template>
						<template v-else>Show More <i class="tbb-icon-long-arrow-right"></i></template>
					</a>
				</template>
			</slot>
		</div>
	</div>
</template>

<script>
	import BaseList from '../mixins/base-list';

	export default {
		mixins: [BaseList]
	}
</script>
